import userListComponent from './user-list.component';

const userListModule = angular.module('userList', [
])
  .component('userList', userListComponent)
  .name;

export default userListModule;
